export default __webpack_public_path__ + "static/media/cibc-logo.42f8f0d7.svg";